import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { ThemeProvider } from '@mui/material';
import { theme } from './theme';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { routesConfig } from './routes/config';
import { FormThemeProvider } from 'react-form-component';
import { HelmetProvider } from 'react-helmet-async';

// Continue with normal app rendering
const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

const router = createBrowserRouter(routesConfig);

root.render(
    <React.StrictMode>
        <ThemeProvider theme={theme}>
            <FormThemeProvider
                theme={{
                    sizes: {
                        borderRadius: 5,
                    },
                    colors: {
                        accent: theme.palette.secondary.main,
                    },
                }}
            >
                <HelmetProvider>
                    <RouterProvider router={router} />
                </HelmetProvider>
            </FormThemeProvider>
        </ThemeProvider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
